module.exports = __webpack_public_path__ + "files/14c996aa3aefa9b4c14d37bea178d3d9.png";